let ageStyleObserver: MutationObserver | null = null;

const ageStyleLabels = [
  '韩系小千金风 / 韩系小清新 / 韩系冷感大女主',
  '韩系小千金风 / 韩系小清新 / 韩系冷感大女主 / 韩系精致通勤'
];

function applyAgeStyleAdjustment() {
  const ageCards = document.querySelectorAll<HTMLElement>('.age-cards .age-card');
  if (ageCards.length < 2) return;
  ageStyleLabels.forEach((label, index) => {
    const styleLine = ageCards[index]?.querySelector<HTMLElement>('strong');
    if (styleLine && styleLine.textContent !== label) styleLine.textContent = label;
  });
}

export function mountAgeStyleAdjustment() {
  applyAgeStyleAdjustment();
  if (ageStyleObserver) return;
  const content = document.querySelector('#content') || document.body;
  ageStyleObserver = new MutationObserver(applyAgeStyleAdjustment);
  ageStyleObserver.observe(content, { childList: true, subtree: true });
}
